import React from "react";

const LabelTitle = ({ label, color = "#000", size, bolder = 600 }) => {
    return (
        <div style={{ color: color, fontSize: size, fontWeight: bolder }}>
            {label}
        </div>
    );
};

export default LabelTitle;
